import { IPaginatedPage } from './pagination.types';

// Runtime mirror of the ambient `CalibrationAssignmentStatus` wire union in
// boilerplate-models.d.ts (which owns the type; this enum owns the values).
export enum CalibrationAssignmentStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
}

// Paged result of the myCalibrationAssignments query (the accumulated assignments
// plus the server's current total). Shared by the Apollo merge policy.
export type ICalibrationAssignmentsPage = IPaginatedPage<ICalibrationAssignment>;

// Result of the lightweight calibrationAssignmentSummary query — the caller's pending count.
export interface ICalibrationAssignmentSummary {
  pendingCount: number;
}
